import React, { useState, useEffect } from "react";
import "./NewPatientRegistration.css";

const LabTestRateCard = ({ screenAction, triggerSave }) => {

  const [formData, setFormData] = useState({
    test_id: "",
    test_name: "",
    category: "",
    fee: ""
  });

  const [isDisabled, setIsDisabled] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [tests, setTests] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);


  const [categoriesList, setCategoriesList] = useState([]);
  const [masterTestsList, setMasterTestsList] = useState([]);

  // 🔥 Generate Test ID

const fetchNextTestId = async () => {
  const user = JSON.parse(localStorage.getItem("user"));

  const res = await fetch(
    `https://hmsapi.emedhatechnologies.com/master/api/lab/test/id?employee_id=${user.id}`
  );

  const data = await res.json();

  setFormData(prev => ({
    ...prev,
    test_id: data.test_id
  }));
};


  useEffect(() => {

  fetchNextTestId(); // ✅ CALL IT
}, []);



useEffect(() => {
    const fetchMasterData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        
        // Fetch Categories and Tests in parallel
        const [catRes, testRes] = await Promise.all([
          fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/test-categories?employee_id=${user.id}`),
          fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/tests?employee_id=${user.id}`)
        ]);

        if (catRes.ok) setCategoriesList(await catRes.json());
        if (testRes.ok) setMasterTestsList(await testRes.json());

      } catch (err) {
        console.error("Error fetching master data:", err);
      }
    };

    fetchMasterData();
    fetchNextTestId(); // ✅ Kept your original call
  }, []);

const handleTestSelection = (e) => {
    const selectedTestName = e.target.value;
    
    // Find the selected test in our master list
    const selectedTest = masterTestsList.find(t => t.test_name === selectedTestName);
    
    if (selectedTest) {
      // Find the matching category name using the category_id from the test
      const matchingCategory = categoriesList.find(c => c.test_category_id === selectedTest.test_category_id);
      
      setFormData({ 
        ...formData, 
        test_name: selectedTestName,
        category: matchingCategory ? matchingCategory.test_category_name : "" 
      });
    } else {
      setFormData({ ...formData, test_name: selectedTestName });
    }
  };


  const getNewTestId = () => {
    return `T${Math.floor(1000 + Math.random() * 9000)}`;
  };

const clearForm = async () => {
  const user = JSON.parse(localStorage.getItem("user"));

  const res = await fetch(
    `https://hmsapi.emedhatechnologies.com/master/api/lab/test/id?employee_id=${user.id}`
  );

  const data = await res.json();

  setFormData({
     test_id: data.test_id,  
    test_name: "",
    category: "",
    fee: ""
  });

  setSearchText("");
  setTests([]);
};

  // 🔍 Search
  const searchTests = async (text) => {
    setSearchText(text);

    if (text.length < 2) {
      setTests([]);
      return;
    }

    const user = JSON.parse(localStorage.getItem("user"));

    const res = await fetch(
      `https://hmsapi.emedhatechnologies.com/master/api/api/labtests/search?q=${text}&employee_id=${user.id}`
    );

    const data = await res.json();

    setTests(data);
    setShowDropdown(true);
  };

const handleCategoryChange = (e) => {
    const selectedCategoryName = e.target.value;
    
    setFormData({
      ...formData,
      category: selectedCategoryName,
      test_name: "", // Clear test name when category changes
      fee: ""        // Clear fee
    });
  };


  // 🔥 Filter tests based on the currently selected category
  const selectedCategoryObj = categoriesList.find(c => c.test_category_name === formData.category);
  
  const filteredTests = selectedCategoryObj 
    ? masterTestsList.filter(t => String(t.test_category_id) === String(selectedCategoryObj.test_category_id))
    : []; // If no category is selected, the test list is empty


  const selectTest = (t) => {
    setFormData(t);

    setSearchText(`${t.test_id} | ${t.test_name}`);

    setShowDropdown(false);

    if (screenAction === "edit") setIsDisabled(false);
    if (screenAction === "view") setIsDisabled(true);
  };

  // 🔄 Mode control
useEffect(() => {
  const init = async () => {

    if (screenAction === "add") {
      clearForm();
      await fetchNextTestId();   // 🔥 WAIT PROPERLY
      setIsDisabled(false);
    }

    if (screenAction === "edit") {
      clearForm();
      await fetchNextTestId();
      setIsDisabled(false);
    }

    if (screenAction === "view") {
      clearForm();
      setIsDisabled(true);
    }
    if(screenAction==="print"){
printForm();
}
  };

  init();
}, [screenAction]);

  // 💾 Save
  useEffect(() => {
    if (triggerSave > 0 && screenAction === "save") {
      handleSubmit();
    }
  }, [triggerSave]);

  const handleSubmit = async () => {

    const user = JSON.parse(localStorage.getItem("user"));

    const payload = {
      ...formData,
      created_by: user.id
    };

     delete payload.created_at;
  delete payload.updated_at;


    const method = formData.created_at ? "PUT" : "POST";

    const url =
      method === "POST"
        ? " https://hmsapi.emedhatechnologies.com/master/api/api/labtest"
        : `https://hmsapi.emedhatechnologies.com/master/api/api/labtest/${formData.test_id}`;

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    if (res.ok) {
      alert("Saved Successfully");
      if (method === "POST") clearForm();
    }
  };


//   const printForm = () => {
//   const newWindow = window.open("", "", "width=900,height=700");
//   const today = new Date().toLocaleDateString();

//   const htmlContent = `
//     <html>
//       <head>
//         <title>Lab Test Rate Card - ${formData.test_id}</title>
//         <style>
//           body {
//             font-family: Arial;
//             padding: 30px;
//             color: #333;
//           }

//           .header {
//             display: flex;
//             justify-content: space-between;
//             border-bottom: 2px solid #b8860b;
//             padding-bottom: 10px;
//           }

//           .header h1 {
//             margin: 0;
//             font-size: 20px;
//           }

//           .title {
//             text-align: right;
//           }

//           .section {
//             margin-top: 20px;
//             padding: 10px;
//             border-left: 4px solid #b8860b;
//             background: #fff8e6;
//             font-weight: bold;
//           }

//           .grid {
//             display: grid;
//             grid-template-columns: 1fr 1fr;
//             gap: 10px;
//             margin-top: 15px;
//           }

//           .item {
//             padding: 8px;
//             border-bottom: 1px dashed #ccc;
//           }

//           .label {
//             font-weight: bold;
//             color: #555;
//           }

//           .footer {
//             margin-top: 40px;
//             text-align: center;
//             font-size: 12px;
//             color: #888;
//           }
//         </style>
//       </head>

//       <body>

//         <div class="header">
//           <div>
//             <h1>EMEDHA CARE HOSPITAL</h1>
//             <p>Lab Test Rate Card</p>
//           </div>

//           <div class="title">
//             <p>Date: ${today}</p>
//           </div>
//         </div>

//         <div class="section">Test Information</div>

//         <div class="grid">

//           <div class="item">
//             <span class="label">Test ID:</span> ${formData.test_id}
//           </div>

//           <div class="item">
//             <span class="label">Test Name:</span> ${formData.test_name}
//           </div>

//           <div class="item">
//             <span class="label">Category:</span> ${formData.category}
//           </div>

//           <div class="item">
//             <span class="label">Fee:</span> ₹${formData.fee}
//           </div>

//         </div>

//         <div class="footer">
//           This is a system generated Lab Test Rate Card
//         </div>

//       </body>
//     </html>
//   `;

//   newWindow.document.write(htmlContent);
//   newWindow.document.close();

//   setTimeout(() => {
//     newWindow.print();
//     newWindow.close();
//   }, 500);
// };


const printForm = () => {
  const newWindow = window.open("", "", "width=900,height=700");
  const today = new Date().toLocaleDateString();

  const htmlContent = `
    <html>
      <head>
        <title>Lab Test Rate Card - ${formData.test_id}</title>
        <style>
          body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            color: #333;
            margin: 0;
            padding: 40px;
          }

          /* Header */
          .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 2px solid #b8860b;
            padding-bottom: 10px;
            margin-bottom: 20px;
          }

          .hospital-info h1 {
            margin: 0;
            color: #2c3e50;
            font-size: 24px;
            text-transform: uppercase;
          }

          .hospital-info p {
            margin: 2px 0;
            font-size: 12px;
            color: #7f8c8d;
          }

          .report-title {
            text-align: right;
          }

          .report-title h2 {
            margin: 0;
            color: #b8860b;
            font-size: 18px;
          }

          /* Section */
          .section-header {
            background: #fffcf2;
            padding: 8px 12px;
            font-weight: bold;
            font-size: 14px;
            border-left: 4px solid #b8860b;
            margin-top: 20px;
            margin-bottom: 10px;
            text-transform: uppercase;
          }

          /* Grid Layout */
          .info-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
            margin-bottom: 20px;
          }

          .info-item {
            font-size: 13px;
            display: flex;
            border-bottom: 1px dotted #ccc;
            padding: 6px 0;
          }

          .label {
            font-weight: 600;
            width: 150px;
            color: #555;
          }

          .value {
            flex: 1;
            font-weight: 500;
            color: #000;
          }

          /* Highlight Fee */
          .fee {
            color: #27ae60;
            font-weight: bold;
          }

          /* Footer */
          .footer {
            margin-top: 50px;
            font-size: 10px;
            text-align: center;
            color: #95a5a6;
            border-top: 1px solid #eee;
            padding-top: 10px;
          }

          .sig-box {
            margin-top: 60px;
            display: flex;
            justify-content: space-between;
          }

          .sig {
            border-top: 1px solid #000;
            width: 200px;
            text-align: center;
            padding-top: 5px;
            font-size: 12px;
          }

          @media print {
            body { padding: 20px; }
            @page { margin: 0.5cm; }
          }
        </style>
      </head>

      <body>

        <div class="header">
          <div class="hospital-info">
            <h1>EMEDHA CARE HOSPITAL</h1>
            <p>123 Medical Park, Health City - 560001</p>
            <p>Phone: +91 98765 43210 | Email: diagnostics@citycare.com</p>
          </div>

          <div class="report-title">
            <h2>LAB TEST RATE CARD</h2>
            <p>Print Date: ${today}</p>
          </div>
        </div>

        <div class="section-header">Test Information</div>

        <div class="info-grid">
          <div class="info-item">
            <span class="label">Test ID:</span>
            <span class="value">${formData.test_id}</span>
          </div>

          <div class="info-item">
            <span class="label">Test Name:</span>
            <span class="value">${formData.test_name}</span>
          </div>

          <div class="info-item">
            <span class="label">Category:</span>
            <span class="value">${formData.category}</span>
          </div>

          <div class="info-item">
            <span class="label">Fee:</span>
            <span class="value fee">₹${formData.fee}</span>
          </div>
        </div>

        <div class="sig-box">
          <div class="sig">Authorized Signature</div>
          <div class="sig">Billing Department</div>
        </div>

        <div class="footer">
          This is a system-generated Lab Test Rate Card. Prices are subject to change without prior notice.
        </div>

      </body>
    </html>
  `;

  newWindow.document.write(htmlContent);
  newWindow.document.close();

  setTimeout(() => {
    newWindow.print();
    newWindow.close();
  }, 500);
};


return (
  <div className="registration-container fade-in">

    {(screenAction === "edit" || screenAction === "view") && (
      <div className="patient-search">
        <label>Search Test</label>

        <input
          type="text"
          value={searchText}
          placeholder="Search Test ID / Name / Category"
          onChange={(e) => searchTests(e.target.value)}
        />

        {showDropdown && tests.length > 0 && (
          <div className="patient-dropdown">
            {tests.map((t) => (
              <div
                key={t.test_id}
                className="patient-item"
                onClick={() => selectTest(t)}
              >
                {t.test_id} | {t.test_name} | {t.category}
              </div>
            ))}
          </div>
        )}
      </div>
    )}

    <form className="luxury-form">

      {/* ✅ HEADER SAME AS APPOINTMENT */}
      <div className="form-section-header">
        <h3>Lab Test Rate Card</h3>
        <p>Manage lab test pricing</p>
      </div>

      {/* ✅ GRID STRUCTURE */}
      <div className="form-grid">

        <div className="input-box read-only">
          <label>Test ID</label>
          <input
            type="text"
            value={formData.test_id || ""}
            disabled
          />
        </div>

   

<div className="input-box">
          <label>Category</label>
          <select
            value={formData.category || ""}
            disabled={isDisabled}
            onChange={handleCategoryChange} 
          >
            <option value="">-- Select Category --</option>
            {categoriesList.map(cat => (
              <option key={cat.test_category_id} value={cat.test_category_name}>
                {cat.test_category_name}
              </option>
            ))}
          </select>
        </div>

        <div className="input-box">
          <label>Test Name</label>
          <select
            value={formData.test_name || ""}
            disabled={isDisabled || !formData.category} 
            onChange={handleTestSelection}
          >
            <option value="">-- Select Lab Test --</option>
            {filteredTests.map(test => (               
              <option key={test.test_id} value={test.test_name}>
                {test.test_name}
              </option>
            ))}
          </select>
        </div>
        <div className="input-box">
          <label>Fee (₹)</label>
          <input
            type="number"
            placeholder="Enter Fee"
            value={formData.fee || ""}
            disabled={isDisabled}
            onChange={(e) =>
              setFormData({ ...formData, fee: e.target.value })
            }
          />
        </div>

      </div>

    </form>
  </div>
);
};

export default LabTestRateCard;